// Google Sign-In Error Messages - User-facing messages for snackbars
export const GOOGLE_ERROR_MESSAGES = {
  GENERIC_ERROR: 'Error signing in with Google. Please try again.',
  POPUP_BLOCKED: 'Please allow popups for Google Sign-In to work.',
  UNAUTHORIZED_DOMAIN: 'This domain is not authorized for Google Sign-In.',
  CONFIGURATION_ERROR: 'Google Sign-In configuration error. Please contact support.',
  ACCOUNT_EXISTS_DIFFERENT_PROVIDER:
    'An account already exists with this email using a different sign-in method.',
  ALLOW_POPUPS: 'Please allow popups and try again.',
} as const

// Google Sign-In Console Messages
export const GOOGLE_CONSOLE_MESSAGES = {
  CLIENT_ID_MISSING: 'Google Client ID not configured',
  SCRIPT_NOT_LOADED: 'Google Sign-In script not loaded',
  ONE_TAP_ERROR: 'Error showing Google One Tap:',
  ONE_TAP_SUCCESS: 'Google One Tap sign-in successful',
  TOKEN_ERROR: 'Google token handling error:',
  INITIALIZATION_ERROR: 'Google Sign-In initialization error:',
  POPUP_ERROR: 'Google popup sign-in error:',
  INVALID_CREDENTIAL: 'Invalid Google credential - token may be expired',
  FEDCM_ERROR:
    'Google FedCM error - this is usually due to browser settings or network issues',
  CONCURRENT_REQUEST_ERROR:
    'Multiple Google Sign-In requests detected - prompts are now throttled to prevent FedCM errors',
} as const

// Google Sign-In Error Strings
export const GOOGLE_ERROR_STRINGS = {
  NO_CREDENTIAL: 'No credential received from Google',
  NO_USER_RETURNED_POPUP: 'No user returned from Google Sign-In',
  NO_USER_RETURNED_CREDENTIAL: 'No user returned from credential sign-in',
} as const

// Phone Authentication Error Messages - User-facing messages for snackbars
export const PHONE_ERROR_MESSAGES = {
  INVALID_PHONE_NUMBER: 'Please enter a valid phone number.',
  INVALID_PHONE_WITH_COUNTRY: 'Please enter a valid phone number with country code.',
  NETWORK_REQUIRED: 'Network connection required. Please check your connection.',
  SERVICE_UNAVAILABLE: 'Phone service unavailable. Please try again later.',
  RECAPTCHA_FAILED:
    'Security verification failed. Please refresh the page and try again.',
  TOO_MANY_ATTEMPTS: 'Too many attempts. Please wait before trying again.',
  SMS_QUOTA_EXCEEDED: 'SMS quota exceeded. Please try again later.',
  VERIFICATION_FAILED: 'Failed to send verification code. Please try again.',
  CODE_VALIDATION_ERROR: 'Error validating code',
  INVALID_CODE: 'Invalid code. Please try again.',
  CODE_SENDING_TROUBLE: 'Trouble texting the code',
} as const

// Phone Authentication Console Messages
export const PHONE_CONSOLE_MESSAGES = {
  VERIFICATION_ERROR: 'Phone verification error:',
  RECAPTCHA_ELEMENT_NOT_FOUND: 'reCAPTCHA: Element with id',
  RECAPTCHA_FOUND_INITIALIZING: 'reCAPTCHA: Found element with id',
  RECAPTCHA_AUTH_UNAVAILABLE: 'reCAPTCHA: Firebase auth not available',
  RECAPTCHA_SUCCESS: 'reCAPTCHA: Successfully initialized verifier',
  RECAPTCHA_INIT_FAILED: 'Failed to initialize reCAPTCHA:',
  RECAPTCHA_CLEAR_ERROR: 'Error clearing reCAPTCHA verifier:',
  CODE_VALIDATION_ERROR: 'Something went wrong. Try again.',
} as const

// Phone Authentication Error Strings
export const PHONE_ERROR_STRINGS = {
  RECAPTCHA_REQUIRED:
    'Phone verification requires reCAPTCHA. Please try again in a moment.',
} as const
